import React from 'react';
import AddCreditCard from '../../components/AddCreditCard/AddCreditCard';
import MainLayout from '../../layout/MainLayout';

export default () => {
    return (
        <MainLayout>
            <AddCreditCard />
        </MainLayout>
    );
};
